import ReactDOM from "react-dom/client";
import App from "./src/App";
import {createElement} from "react";

const rootElement = document.createElement("div");
document.body.appendChild(rootElement);

ReactDOM.createRoot(rootElement)
  .render(createElement(App));
